export * from './ts-file.parser';
export * from './ts-file-component.parser';
export * from './ts-file-module.parser';
